export default class CommentsTextArea {
  constructor() {
    this.input = `<textarea class="form__textarea" cols="18" id="comments" maxlength="200" name="comments"
                   placeholder="Comments or Questions" rows="1" type="text" data-qa="comments-input"></textarea>`;
    this.label = `<label class="nhs-u-text--visually-hidden" for="comments">Comments or Questions</label>`;
  }

  getHtml() {
    return `${this.label}${this.input}`;
  }
}
